import { Component, AfterViewInit, Input } from '@angular/core';
import * as Chart from 'chart.js';
import { ApiService } from './../services/api.service';
import { ResponseService } from './../services/response.service';
import { Daterange } from './../interfaces/daterange.model';

@Component({
    selector: 'server-rrd',
    templateUrl: './server-rrd.component.html'
}) export class ServerRRDComponent implements AfterViewInit {
    @Input() serviceID: Number;
    rrdData: any;
    canvas: any;
    ctx: any;
    traffic_dates: any;
    myChart: Array<Chart> = new Array();
    myChildren : Array<any> = new Array();
    rrdViews : any = "";
    public dates : Array<any> = new Array();
    public daterange: Daterange = {};
    public dateFrom: Date = new Date();
    public dateTo: Date = new Date();
    public dateInitialized: boolean = false;

    public settings = {
        bigBanner: true,
        timePicker: true,
        format: 'dd-MM-yyyy hh:mm',
        defaultOpen: false
    }
    public datasets_new: any;
    public rrd_loaded: boolean = false;
    constructor(
        private responseService: ResponseService,
        private apiService: ApiService
    ) { }

    timeList = [
        {id: 1, name: '1 godzina', selected: true},
        {id: 2, name: '10 godzin', selected: false},
        {id: 3, name: 'dzień', selected: false},
        {id: 4, name: 'tydzień', selected: false},
        {id: 5, name: 'miesiąc', selected: false},
        {id: 6, name: 'rok', selected: false}
    ];

    typeList = [
        {id: 0, name: 'Ruch sieciowy',route: 'transfers', selected: true},
        {id: 1, name: 'Pakiety', route: 'packets' ,selected: false}
    ];

    graphTypeList = [
        {id: 0, name: 'Liniowy', type: 'linear' ,selected: true},
        {id: 1, name: 'Logarytmiczny', type: 'logarithmic' , selected: false}
    ];

    displayType = [
        {id: 0, name: 'Po obu stronach linii', type: 'over-under'},
        {id: 1, name: 'Powyżej linii', type: 'over'}
    ];

    selectedTime=this.timeList[0];
    selectedGraphType=this.graphTypeList[0];
    selectedType=this.typeList[0];
    selectedDisplayType=this.displayType[1];




    private formatBytes(a, b) { if (0 == a) return "0 Bytes"; var c = 1024, d = b || 2, e = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"], f = Math.floor(Math.log(a) / Math.log(c)); return parseFloat((a / Math.pow(c, f)).toFixed(d)) + " " + e[f] }


    private strapEnglishNames(name){
        var split_name = name.split(':');
        if(split_name[0] == 'bytes_in')return 'Przychodzące: '+ split_name[1];
        else if(split_name[0] == 'packets_in')return 'Przychodzące: '+ split_name[1];
        return 'Wychodzące: '+ split_name[1];
    }

    private toTime(unix) {
        unix = new Date(unix * 1000);
        return unix.getDate() + '-' + (unix.getMonth() + 1) + '-' + unix.getFullYear() + ' ' + unix.getHours() + ':' + unix.getMinutes();
    }

    reloadData(){
        // let myHeight : number = this.canvas.getAttribute('height');
        // let myWidth : number = this.canvas.getAttribute('width');
        
        // for(let o of this.myChart){
        //     let myHeight : number = this.myChildren[o.id].getAttribute('height');
        //     let myWidth : number = this.myChildren[o.id].getAttribute('width');
        //     o.destroy();
        //     this.myChildren[o.id].setAttribute('height', myHeight);
        //     this.myChildren[o.id].setAttribute('width', myWidth);
        // }


        // this.canvas.setAttribute('height', myHeight);
        // this.canvas.setAttribute('width', myWidth);
        
        // console.log('--------------------');
        // console.log(myHeight);
        // console.log(myWidth);
        this.ngAfterViewInit();
    }
    //This function strips dates from format 'DD-MM-YYYY HH:ii' to format 'HH:ii' or 'DD-MM-YYYY' 
    //depending if client choose time 10h, 1d or 1w, 1y
    stripDates(dates_dataset : Array<String>){
        let new_dates_dataset : Array<any> = Array();
        dates_dataset.forEach(element => {
            var local_time = element.split(' ');
            if(this.selectedTime.id == 1 || this.selectedTime.id == 2 || this.selectedTime.id == 3)
            {
                var time = local_time[1].split(':');
                var parsed_time = time[0] + ':' + String('00' + time[1]).slice(-2);
                new_dates_dataset.push(parsed_time);
            }else
            {
                new_dates_dataset.push(local_time[0]);
            }
            
        });
        //console.log(new_dates_dataset);
        return new_dates_dataset;
    }

    drawChart(canvas, newDataset_tr_in, newDataset_tr_out, traffic_dates , index){
        var datasets_new = [];
        
        datasets_new.push(newDataset_tr_in);
        datasets_new.push(newDataset_tr_out);
        let child_div : any = document.createElement('div');
        let child_canvas : any = document.createElement('canvas');
        child_canvas.id = 'rrd-canvas-' + index;
        child_canvas.className = 'rrd-canvas';
        child_div.id = 'rrd-wrapper-' + index;
        
        child_div.className = 'rrd-wrapper';
        if(this.rrdData.length === 1){child_div.className = 'rrd-wrapper-single';}
        child_div.append(child_canvas);
        //child canvases add to array
        
        
        //this.canvas.empty();
        canvas.append(child_div);

        let child : any = document.getElementById('rrd-canvas-'+index);
        this.ctx = child.getContext('2d');
        var selected_type = this.selectedType;
        var selected_display = this.selectedDisplayType;

        let chartNew : Chart = new Chart(this.ctx, {
            type: 'line',
            data: {
                labels: this.stripDates(traffic_dates),
                datasets: datasets_new
            },
            options: 
            {
                elements: 
                {
                    line: 
                    {
                        tension: 0
                    }
                },
                tooltips: 
                {
                    callbacks: 
                    {
                        label: function (tooltip, value) 
                        {
                            var tooltip_response = Array();
                            var wart : any =  tooltip.yLabel;
                            var type : any = "Wychodzące";
                            if(tooltip.datasetIndex == 1)type = "Przychodzące";
                            /** Tutaj nie należy tego zmieniać ze względu że to tooltip */
                            if(wart<0) wart = wart * -1;

                            if(selected_type.route == "transfers"){
                                //tooltip_response.push('Wartość: ' + parseInt((parseFloat(wart) * 8).toString()) + ' bits/s');
                                var a : any = parseInt((parseFloat(wart) * 8).toString());
                                var b = 2;
                                if (0 == a) {
                                    tooltip_response.push(type + ": 0 bits/s");
                                    return tooltip_response;
                                } 
                                var c = 1024, d = b || 2, e = ["bits/s", "Kb/s", "Mb/s", "Gb/s", "Tb/s", "Pb/s", "Eb/s", "Zb/s", "Yb/s"], f = Math.floor(Math.log(a) / Math.log(c)); 
                                tooltip_response.push(type + ": " + parseFloat((a / Math.pow(c, f)).toFixed(d))+ " " + e[f]);
                            }else{
                                tooltip_response.push(type + ': ' + parseInt(wart) +'/s');
                            }
                            return tooltip_response;
                        }
                    }
                },
                scales: {
                    yAxes: [{
                        type: this.selectedGraphType.type,
                        ticks: {
                            beginAtZero: this.selectedDisplayType.type === 'over',
                            /** @todo napisać funkcję rozwiązującą ładnie step size */
                            //stepSize: 256,
                            callback: function(value, index){
                                if(selected_type.route == 'transfers'){
                                    if(value < 0) value = value * -1;
                                    var a: any  = parseInt((parseFloat(value) * 8).toString());
                                    var b = 0;
                                    if (0 == a) return "0 bits/s"; var c = 1024, d = b || 2, e = ["bits/s", "Kb/s", "Mb/s", "Gb/s", "Tb/s", "Pb/s", "Eb/s", "Zb/s", "Yb/s"], f = Math.floor(Math.log(a) / Math.log(c)); return "" + parseFloat((a / Math.pow(c, f)).toFixed(d))+ " " + e[f];
                                }
                                else if(selected_type.route == 'packets' && selected_display.type == 'over-under'){
                                    if(value<0) value = value * -1;
                                    return value;
                                }else if(selected_type.route == 'packets' && selected_display.type == 'over'){
                                    return value;
                                }
                                return parseInt(value);
                            },
                        },
                        
                    },
                    ]
                },
                responsive: false,
                display: true,
            }
        });
        this.myChildren.splice(index,0,child);
        this.myChart.splice(index,0,chartNew);
    }

    getChangedDate($event){
        this.daterange = $event;
        this.reloadData();
    }

    onDateFromSelect($event){
        this.dateFrom = $event;
        this.reloadData();
    }
    onDateToSelect($event){
        this.dateTo = $event;
        this.reloadData();
    }

    firstInitDate()
    {
        if(this.dateInitialized == false){
            this.dateFrom.setDate(this.dateFrom.getDate() - 1);
        }
        this.dateInitialized = true;
    }

    ngAfterViewInit() {
        this.firstInitDate();
        this.apiService.get(
            '/rrd/' + this.selectedType.route + '/' + this.serviceID + 
            '?date_from=' + this.dateFrom.getTime() + '&date_to=' + this.dateTo.getTime()
            ).subscribe(
            (response) => {
                
                const data = this.responseService.success(false, response, 'data');
                this.rrdData = data;
                if(!(this.rrdData.length === 0)){
                    this.rrd_loaded = true;
                    var rrdData = this.rrdData;
                    var size_table = this.rrdData.length;

                    
                    let canvas = document.getElementById('rrd-views') as HTMLDivElement;
                    canvas.innerHTML ="";
                    //console.log('Data: ');
                    //console.log(data);
                    for (var i = 0; i < size_table; i++) {
                        if(rrdData[i] === null){
                            return ;
                        }
                        var traffic_in = rrdData[i].data_points.data[0].data;
                        var traffic_out = rrdData[i].data_points.data[1].data;
                        var selectedGraphType_local = this.selectedGraphType.type;
                        var selected_display = this.selectedDisplayType;
                        var traffic_in_processed = Object.keys(traffic_in).map(function (key, index) {
                            return traffic_in[key];
                        });
                        var traffic_out_processed = Object.keys(traffic_out).map(function (key, index) {
                            if(selectedGraphType_local == 'linear' && selected_display.type === 'over-under'){
                                var tr_data_out : any = traffic_out[key] * -1;
                                return tr_data_out;
                            }else if(selectedGraphType_local == 'linear' && selected_display.type === 'over'){
                                var tr_data_out : any = traffic_out[key];
                                return tr_data_out;
                            }
                            return traffic_out[key];
                        });

                        var traffic_dates = Object.keys(traffic_in).map(function (key, index) {
                            let unix = new Date(Number(key) * 1000);
                            let traffic_date = unix.getDate() + '-' + (unix.getMonth() + 1) + '-' + unix.getFullYear() + ' ' + unix.getHours() + ':';
                            if(unix.getMinutes() == 0){ 
                                traffic_date+='00';
                            }
                            else {
                                traffic_date+=unix.getMinutes();
                            }
                            return traffic_date;
                        
                        });
                        var newDataset_tr_in = {
                            label: this.strapEnglishNames(rrdData[i].data_points.data[0].legend),
                            data: traffic_in_processed,
                            
                            borderColor: '#002A9733',
                            backgroundColor: '#002A9711',
                        };
                        var newDataset_tr_out = {
                            label: this.strapEnglishNames(rrdData[i].data_points.data[1].legend),
                            data: traffic_out_processed,
                            
                            borderColor: '#00CF0033',
                            backgroundColor: '#00CF0011',
                        };
                        this.drawChart(canvas, newDataset_tr_in, newDataset_tr_out, traffic_dates , i);
                    }
                    
                }else{
                    this.rrd_loaded = false;
                }
            },
            (error) => {
                this.rrd_loaded = false;
                this.responseService.error(error);
            }
        );
    };
}


// WEBPACK FOOTER //
// ./src/app/server/server-rrd.component.ts